export default {
  en: {
    period: 'Period',
    addPeriod: 'Add Period',
    addRoom: 'Add Room',
    alertOverlap: 'Period is Overlap'
  },
  th: {
    period: 'ช่วงเวลา',
    addPeriod: 'เพิ่มช่วงเวลา',
    addRoom: 'เพิ่มห้อง',
    alertOverlap: 'ช่วงเวลาซ้อนทับกัน'
  }
}
